<ng-container>
  <div class="variant-selector">
    <div class="variant-name">{{ 'variant.color' | cxTranslate }}</div>
    <ul class="colors selector">
      @for (variant of variants; track variant) {
      <li
        [ngClass]="{ selected: variant.code == product.code }"
        [class.out-stock]="
          (product?.stock?.stockLevelStatus == 'outOfStock' && variant.code == product.code) ||
          variant?.option?.stock?.stockLevelStatus == 'outOfStock'
        "
        class="color"
        (click)="changeColor(variant.option.code, variant.option.name)"
      >
        <cx-media
          matTooltip="{{ variant?.name }}"
          [matTooltipPosition]="'below'"
          matTooltipClass="image-tooltip"
          aria-label="Image that displays a tooltip in bottom"
          [alt]="variant?.name"
          [container]="variant.variantOptionQualifiers[0].image"
          [class.is-missing-fish]="businessType === 'fish'"
          removeImageTitleAttr
        ></cx-media>
      </li>
      }
    </ul>
  </div>
</ng-container>
